import React, { CSSProperties, FC, ReactNode } from 'react';
import { Collapse, Divider } from 'antd';
import { ExpandIconPosition } from 'antd/es/collapse/Collapse';
import { CollapsibleType } from 'antd/es/collapse/CollapsePanel';
import { styled } from 'styled-components';

interface SectionCollapseProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  children?: ReactNode;
  extra?: ReactNode;
  ghost?: boolean;
  style?: CSSProperties;
  expandIconPosition?: ExpandIconPosition;
  collapsible?: CollapsibleType;
  defaultOpen?: boolean;
}

const SectionCollapse: FC<SectionCollapseProps> = ({
  title,
  subtitle,
  children,
  extra,
  ghost = false,
  style = {},
  expandIconPosition = 'end',
  collapsible = 'icon',
  defaultOpen,
}) => {
  return (
    <CollapseWrapper
      expandIconPosition={expandIconPosition}
      collapsible={collapsible}
      ghost={ghost}
      style={style}
      defaultActiveKey={defaultOpen ? '1' : '0'}
    >
      <Collapse.Panel
        style={{ padding: 0 }}
        extra={
          extra && (
            <ExtraWrapper>
              {extra}
              <Divider
                type="vertical"
                style={{ height: '2rem', margin: '0px 16px' }}
              />
            </ExtraWrapper>
          )
        }
        header={
          <HeaderWrapper>
            <Title>{title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </HeaderWrapper>
        }
        key="1"
      >
        {children}
      </Collapse.Panel>
    </CollapseWrapper>
  );
};

const CollapseWrapper = styled(Collapse)`
  align-items: center;
  background-color: white;

  border: none;

  & > .ant-collapse-item {
    border-bottom: none;
  }

  box-shadow: 0 4px 9px 0 rgb(22 26 29 / 5%);

  & > .ant-collapse-item > .ant-collapse-header {
    align-items: center;
  }
  & > .ant-collapse-item > .ant-collapse-header > .ant-collapse-expand-icon {
    padding-inline-start: 0 !important;
  }
`;

const ExtraWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

const Subtitle = styled.div`
  color: #707070;
  font-size: 12px;
`;

export default SectionCollapse;
